/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createVideoAudioInputUploadResponseFromDiscriminatorValue, serializeInitiateVideoAudioInputUploadRequest, serializeVideoAudioInputUploadResponse, type HttpValidationProblemDetails, type IError, type InitiateVideoAudioInputUploadRequest, type VideoAudioInputUploadResponse } from '../../../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/edit/audio/uploads/initiate
 */
export interface InitiateRequestBuilder extends BaseRequestBuilder<InitiateRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<VideoAudioInputUploadResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: InitiateVideoAudioInputUploadRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<VideoAudioInputUploadResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: InitiateVideoAudioInputUploadRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InitiateRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/edit/audio/uploads/initiate";
/**
 * Metadata for all the requests in the request builder.
 */
export const InitiateRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: InitiateRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createVideoAudioInputUploadResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeInitiateVideoAudioInputUploadRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
